// Configuration pour l'API Google Analytics
export const GA_CONFIG = {
  // Remplacez ces valeurs par vos vraies données
  VIEW_ID: import.meta.env.VITE_GA_VIEW_ID || 'your_google_analytics_view_id',
  PRIVATE_KEY: import.meta.env.VITE_GA_PRIVATE_KEY || 'your_private_key',
  CLIENT_EMAIL: import.meta.env.VITE_GA_CLIENT_EMAIL || 'your_service_account_email@leaderpromed-ab6e1.iam.gserviceaccount.com',
};

// Instructions pour obtenir ces valeurs :
// 1. VIEW_ID : Dans Google Analytics > Admin > View Settings > View ID
// 2. PRIVATE_KEY : Dans le fichier JSON téléchargé du compte de service
// 3. CLIENT_EMAIL : Dans le fichier JSON téléchargé du compte de service

export interface AnalyticsData {
  users: number;
  pageViews: number;
  sessions: number;
  bounceRate: number;
  error?: string;
}

export const getGoogleAnalyticsData = async (): Promise<AnalyticsData> => {
  try {
    // Vérifier si les variables d'environnement sont configurées
    if (!GA_CONFIG.VIEW_ID || !GA_CONFIG.PRIVATE_KEY || !GA_CONFIG.CLIENT_EMAIL) {
      console.warn('Google Analytics API non configurée. Utilisez le dashboard Firebase Analytics.');
      return getFallbackData();
    }

    // Solution pour shared hosting : utiliser l'API Google Analytics côté client
    // Note: Cette méthode est limitée car elle nécessite une authentification côté serveur
    // Pour les vraies données, utilisez le dashboard Firebase Analytics
    
    console.log('📊 Configuration Google Analytics détectée');
    console.log('View ID:', GA_CONFIG.VIEW_ID);
    console.log('Client Email:', GA_CONFIG.CLIENT_EMAIL);
    
    // Pour shared hosting, nous utilisons des données simulées
    // Les vraies données sont disponibles dans Firebase Analytics
    return {
      users: 0,
      pageViews: 0,
      sessions: 0,
      bounceRate: 0,
      error: 'Pour les vraies données, utilisez le dashboard Firebase Analytics. Les données côté client sont limitées sur shared hosting.'
    };

  } catch (error) {
    console.error('Erreur lors de la récupération des données Google Analytics:', error);
    return getFallbackData();
  }
};

const getFallbackData = (): AnalyticsData => {
  return {
    users: 0,
    pageViews: 0,
    sessions: 0,
    bounceRate: 0,
    error: 'Configuration manquante'
  };
};

// Fonction pour rediriger vers Firebase Analytics
export const openFirebaseAnalytics = () => {
  window.open('https://console.firebase.google.com/project/leaderpromed-ab6e1/analytics', '_blank');
};

// Fonction pour rediriger vers Google Analytics
export const openGoogleAnalytics = () => {
  window.open('https://analytics.google.com', '_blank');
}; 